import { fetchAll, fetchFiltered, show, add, edit } from '@/api/permission'

const state = {
  all: [],
  isLoading: false,
  permissionById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const permissions = await fetchAll()
      commit('setAll', permissions)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const permission = await show(id)
      commit('setPermissionById', permission)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const permissions = await fetchFiltered(queriesParams)
      commit('setAll', permissions)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await add(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.permissionById = null
    state.isLoading = false
  },

  setAll (state, permissions) {
    state.all = permissions
  },

  setPermissionById (state, permission) {
    const { id, name, tag, isPublic } = permission
    state.permissionById = { id, name, tag, isPublic }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
